// @ts-nocheck
import { PICS_URL } from "../api";

const advantagesFunction = (advantagesItems) => {
  let img = "<img />";
  for (let advantage of advantagesItems) {
    let advantageFull = img + advantage.text_1 + advantage.text_2;
    switch (advantage.title) {
      case "advantages1":
        document.querySelectorAll(".benefit-item")[0].innerHTML = advantageFull;
        document.querySelectorAll(".benefit-item")[0].querySelector("img").src =
          PICS_URL + advantage.icon_1;
        document
          .querySelectorAll(".benefit-item")[0]
          .querySelector("h3")
          .classList.add("benefit-item__title");
        document
          .querySelectorAll(".benefit-item")[0]
          .querySelector("p")
          .classList.add("benefit-item__descr");
        break;
      case "advantages2":
        document.querySelectorAll(".benefit-item")[1].innerHTML = advantageFull;
        document.querySelectorAll(".benefit-item")[1].querySelector("img").src =
          PICS_URL + advantage.icon_1;
        document
          .querySelectorAll(".benefit-item")[1]
          .querySelector("h3")
          .classList.add("benefit-item__title");
        document
          .querySelectorAll(".benefit-item")[1]
          .querySelector("p")
          .classList.add("benefit-item__descr");
        break;
      case "advantages3":
        document.querySelectorAll(".benefit-item")[2].innerHTML = advantageFull;
        document.querySelectorAll(".benefit-item")[2].querySelector("img").src =
          PICS_URL + advantage.icon_1;
        document
          .querySelectorAll(".benefit-item")[2]
          .querySelector("h3")
          .classList.add("benefit-item__title");
        document
          .querySelectorAll(".benefit-item")[2]
          .querySelector("p")
          .classList.add("benefit-item__descr");
        break;
      case "advantages4":
        document.querySelectorAll(".benefit-item")[3].innerHTML = advantageFull;
        document.querySelectorAll(".benefit-item")[3].querySelector("img").src =
          PICS_URL + advantage.icon_1;
        document
          .querySelectorAll(".benefit-item")[3]
          .querySelector("h3")
          .classList.add("benefit-item__title");
        document
          .querySelectorAll(".benefit-item")[3]
          .querySelector("p")
          .classList.add("benefit-item__descr");
        break;
      case "advantages5":
        document.querySelectorAll(".benefit-item")[4].innerHTML = advantageFull;
        document.querySelectorAll(".benefit-item")[4].querySelector("img").src =
          PICS_URL + advantage.icon_1;
        document
          .querySelectorAll(".benefit-item")[4]
          .querySelector("h3")
          .classList.add("benefit-item__title");
        document
          .querySelectorAll(".benefit-item")[4]
          .querySelector("p")
          .classList.add("benefit-item__descr");
        break;

      default:
        break;
    }
  }
};

const statisticsFunction = (statisticsItems) => {
  let img = "<img />";
  for (let stat of statisticsItems) {
    switch (stat.title) {
      case "stats1":
        document.querySelectorAll(".about-card__item")[0].innerHTML =
          img + stat.text_1 + stat.text_2;
        document
          .querySelectorAll(".about-card__item")[0]
          .querySelector("img").src = PICS_URL + stat.icon_1;
        document
          .querySelectorAll(".about-card__item")[0]
          .querySelector("img")
          .classList.add("about-card__img");
        document
          .querySelectorAll(".about-card__item")[0]
          .querySelector("h3")
          .classList.add("about-card__title");
        document
          .querySelectorAll(".about-card__item")[0]
          .querySelector("p")
          .classList.add("about-card__descr");
        break;
      case "stats2":
        document.querySelectorAll(".about-card__item")[2].innerHTML =
          img + stat.text_1 + stat.text_2;
        document
          .querySelectorAll(".about-card__item")[2]
          .querySelector("img").src = PICS_URL + stat.icon_1;
        document
          .querySelectorAll(".about-card__item")[2]
          .querySelector("img")
          .classList.add("about-card__img");
        document
          .querySelectorAll(".about-card__item")[2]
          .querySelector("h3")
          .classList.add("about-card__title");
        document
          .querySelectorAll(".about-card__item")[2]
          .querySelector("p")
          .classList.add("about-card__descr");
        break;
      case "stats3":
        document.querySelectorAll(".about-card__item")[1].innerHTML =
          img + stat.text_1 + stat.text_2;
        document
          .querySelectorAll(".about-card__item")[1]
          .querySelector("img").src = PICS_URL + stat.icon_1;
        document
          .querySelectorAll(".about-card__item")[1]
          .querySelector("img")
          .classList.add("about-card__img");
        document
          .querySelectorAll(".about-card__item")[1]
          .querySelector("h3")
          .classList.add("about-card__title");
        document
          .querySelectorAll(".about-card__item")[1]
          .querySelector("p")
          .classList.add("about-card__descr");
        break;
      case "stats4_mini":
        document.querySelectorAll(".about-card__item-small")[0].innerHTML =
          stat.text_1 + stat.text_2;
        document
          .querySelectorAll(".about-card__item-small")[0]
          .querySelector("h3")
          .classList.add("about-card__title");
        document
          .querySelectorAll(".about-card__item-small")[0]
          .querySelector("p")
          .classList.add("about-card__descr");
        break;
      case "stats5_mini":
        document.querySelectorAll(".about-card__item-small")[1].innerHTML =
          stat.text_1 + stat.text_2;
        document
          .querySelectorAll(".about-card__item-small")[1]
          .querySelector("h3")
          .classList.add("about-card__title");
        document
          .querySelectorAll(".about-card__item-small")[1]
          .querySelector("p")
          .classList.add("about-card__descr");
        break;

      default:
        break;
    }
  }
  document.querySelectorAll(".about-card__item-small")[1].innerHTML =
    document.querySelectorAll(".about-card__item-small")[1].innerHTML +
    "<div className='small-border-bottom'><div className='small-border-active'></div></div>";
};

const sliderFunction = (sliderItems) => {
  for (let slide of sliderItems) {
    switch (slide.title) {
      case "slider1":
        document
          .querySelectorAll(".situation-dialog-upper")[0]
          .querySelector("img").src = PICS_URL + slide.icon_1;
        document
          .querySelectorAll(".situation-dialog-lower")[0]
          .querySelector("img").src = PICS_URL + slide.icon_2;
        document.querySelectorAll(".top-bubble")[0].innerHTML = slide.text_1;
        document.querySelectorAll(".bottom-bubble")[0].innerHTML = slide.text_2;
        break;
      case "slider2":
        document
          .querySelectorAll(".situation-dialog-upper")[1]
          .querySelector("img").src = PICS_URL + slide.icon_1;
        document
          .querySelectorAll(".situation-dialog-lower")[1]
          .querySelector("img").src = PICS_URL + slide.icon_2;
        document.querySelectorAll(".top-bubble")[1].innerHTML = slide.text_1;
        document.querySelectorAll(".bottom-bubble")[1].innerHTML = slide.text_2;
        break;
      case "slider3":
        document
          .querySelectorAll(".situation-dialog-upper")[2]
          .querySelector("img").src = PICS_URL + slide.icon_1;
        document
          .querySelectorAll(".situation-dialog-lower")[2]
          .querySelector("img").src = PICS_URL + slide.icon_2;
        document.querySelectorAll(".top-bubble")[2].innerHTML = slide.text_1;
        document.querySelectorAll(".bottom-bubble")[2].innerHTML = slide.text_2;
        break;
      case "slider4":
        document
          .querySelectorAll(".situation-dialog-upper")[3]
          .querySelector("img").src = PICS_URL + slide.icon_1;
        document
          .querySelectorAll(".situation-dialog-lower")[3]
          .querySelector("img").src = PICS_URL + slide.icon_2;
        document.querySelectorAll(".top-bubble")[3].innerHTML = slide.text_1;
        document.querySelectorAll(".bottom-bubble")[3].innerHTML = slide.text_2;
        break;

      default:
        break;
    }
  }

  document
    .querySelectorAll(".situation-dialog-upper")[4]
    .querySelector("img").src = PICS_URL + sliderItems[0].icon_1;
  document
    .querySelectorAll(".situation-dialog-lower")[4]
    .querySelector("img").src = PICS_URL + sliderItems[0].icon_2;
  document.querySelectorAll(".top-bubble")[4].innerHTML = sliderItems[0].text_1;
  document.querySelectorAll(".bottom-bubble")[4].innerHTML =
    sliderItems[0].text_2;
};

export { advantagesFunction, statisticsFunction, sliderFunction };
